import { ElementColumnInfo } from "../../composition-filter";

export interface ColumnInfo {
  title: string;
  minimum: number;
  maximum: number;
  step: number;
}

export enum AirMeltElementType {
  Carbon = "carbon",
  Manganese = "manganese",
  Silicon = "silicon",
  Chromium = "chromium",
  Nickel = "nickel",
  Molybdenum = "molybdenum",
  Phosphorus = "phosphorus",
  Sulfur = "sulfur",
  Vanadium = "vanadium",
  Tungsten = "tungsten",
  Cobalt = "cobalt",
  Copper = "copper",
  Iron = "iron"
}

export const carbonInfo: ElementColumnInfo = {
  element: AirMeltElementType.Carbon,
  title: "Carbon",
  minimum: 0, //0.02,
  maximum: 14.0, // TODO JL - outlier?
  step: 1
};

export const manganeseInfo: ElementColumnInfo = {
  element: AirMeltElementType.Manganese,
  title: "Manganese",
  minimum: 0.0,
  maximum: 8.0,
  step: 1
};

export const siliconInfo: ElementColumnInfo = {
  element: AirMeltElementType.Silicon,
  title: "Silicon",
  minimum: 0.0,
  maximum: 10, // 9.25,
  step: 1
};

export const chromiumInfo: ElementColumnInfo = {
  element: AirMeltElementType.Chromium,
  title: "Chromium",
  minimum: 0.0,
  maximum: 60.0,
  step: 10
};

export const nickelInfo: ElementColumnInfo = {
  element: AirMeltElementType.Nickel,
  title: "Nickel",
  minimum: 0.0,
  maximum: 100, //95.0,
  step: 10
};

export const molybdenumInfo: ElementColumnInfo = {
  element: AirMeltElementType.Molybdenum,
  title: "Molybdenum",
  minimum: 0.0,
  maximum: 35, //32.0,
  step: 5
};

export const phosphorusInfo: ElementColumnInfo = {
  element: AirMeltElementType.Phosphorus,
  title: "Phosphorus",
  minimum: 0.0,
  maximum: 0.2, //0.17,
  step: 0.05
};

export const sulfurInfo: ElementColumnInfo = {
  element: AirMeltElementType.Sulfur,
  title: "Sulfur",
  minimum: 0.0,
  maximum: 0.3,
  step: 0.05
};

export const vanadiumInfo: ElementColumnInfo = {
  element: AirMeltElementType.Vanadium,
  title: "Vanadium",
  minimum: 0.0,
  maximum: 5, //4.88,
  step: 0.5
};

export const tungstenInfo: ElementColumnInfo = {
  element: AirMeltElementType.Tungsten,
  title: "Tungsten",
  minimum: 0.0,
  maximum: 20, //18.5,
  step: 2
};

export const cobaltInfo: ElementColumnInfo = {
  element: AirMeltElementType.Cobalt,
  title: "Cobalt",
  minimum: 0.0,
  maximum: 70, //61.5,
  step: 10
};

export const copperInfo: ElementColumnInfo = {
  element: AirMeltElementType.Copper,
  title: "Copper",
  minimum: 0.0,
  maximum: 4.0,
  step: 0.25
};

export const ironInfo: ElementColumnInfo = {
  element: AirMeltElementType.Iron,
  title: "Iron",
  minimum: 0.0,
  maximum: 20, //19.5,
  step: 1
};

export const solidusFInfo: ColumnInfo = {
  title: "Solidus (\u00B0F)",
  minimum: 2320,
  maximum: 2800, //2770.0,
  step: 40
};

export const liquidousFInfo: ColumnInfo = {
  title: "Liquidus (\u00B0F)",
  minimum: 2360,
  maximum: 2800,
  step: 40
};

export const airMeltElementalColumns: ElementColumnInfo[] = [
  carbonInfo,
  manganeseInfo,
  siliconInfo,
  chromiumInfo,
  nickelInfo,
  molybdenumInfo,
  phosphorusInfo,
  sulfurInfo,
  vanadiumInfo,
  tungstenInfo,
  cobaltInfo,
  copperInfo,
  ironInfo
];
